export default "/vendor/danger.3a3ec11eee351f22431ff0e8bf9cac6f.ttf";